import { createReducer, createAction } from '@reduxjs/toolkit';

const initState = {
  storage: {
    isEditMode: undefined,
    mode: undefined,
    modeHistory: undefined,
    data: undefined,
    dataHistory: undefined,
    isDataChanged: undefined,
  },
};

export const setStorage = createAction('productionConnectorSetup/setStorage');
export const clear = createAction('clear');

export default createReducer(initState, {
  [setStorage]: (state, action) => ({
    ...state,
    storage: {
      ...state.storage,
      ...action.payload,
    },
  }),
  [clear]: () => {
    return initState;
  },
});
